import React, {FC, Fragment, ReactElement} from 'react';
import {Col} from "antd";
import {AttemptsMenuCard} from "../components/AttemptsMenuCard";
import {Outlet} from "react-router-dom";

interface Props {
    attemptId?: string;
}

export const Exercise: FC<Props> = ({attemptId}): ReactElement => {
    return (
        <Fragment>
            <Col xs={24} xl={6}>
                <AttemptsMenuCard attemptId={attemptId}/>
            </Col>
            <Col xs={24} xl={18} style={{display: 'block'}}>
                <Outlet/>
            </Col>
        </Fragment>
    );
};
